import React from 'react';
import { Typography, Stack, TextField, Grid, Box } from '@mui/material';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import formatISO from 'date-fns/formatISO'
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

//SMTWHFA
const daysofweek = [
    {"name":"Sun","value":"S"}, 
    {"name":"Mon","value":"M"}, 
    {"name":"Tues","value":"T"}, 
    {"name":"Weds","value":"W"}, 
    {"name":"Thur","value":"H"}, 
    {"name":"Fri","value":"F"}, 
    {"name":"Sat","value":"A"}
]

const TimeSpan = (props) => {
    const [values, setValues] = React.useState(props.timespan);
    const [edited, setEdited] = React.useState(false);
    const selectedProfile = props.selectedProfile;
    const setSelectedProfile = props.setSelectedProfile;
    const myTs = props.myTs;

    React.useEffect(() => {
        const myTs = selectedProfile.timeSpans.find(ts => ts.days === values.dow.value);
        if(!myTs) {
            setValues({
                ...values,
                included: false,
                starttime: "2014-08-18T06:00:00",
                endtime: "2014-08-18T21:00:00"
            })
        }
    },[selectedProfile])
    
    React.useEffect(() => {
        if(myTs && !values.included) {
            const start = new Date();
            start.setHours(myTs.startHour);
            start.setMinutes(myTs.startMinute);
            const end = new Date();
            end.setHours(myTs.endHour);
            end.setMinutes(myTs.endMinute);
            setValues({
                ...values,
                included: true,
                starttime: formatISO(start),
                endtime: formatISO(end)
            })
        }
    },[myTs, values])

    React.useEffect(() => {
        if(null !== selectedProfile && edited) {
            console.log(selectedProfile);
            const mySelectedProfile = {...selectedProfile}

            const startTime = new Date(values.starttime);
            const endTime = new Date(values.endtime);
            const include = values.included;
            const myTs = mySelectedProfile.timeSpans.find(ts => ts.days === values.dow.value);
            if(include) {
                if(myTs) {
                    let updatedTs = {...myTs,
                        startHour: startTime.getHours(),
                        startMinute: startTime.getMinutes(),
                        endHour: endTime.getHours(),
                        endMinute: endTime.getMinutes()}
                    let index = mySelectedProfile.timeSpans.findIndex(ts => ts.days === myTs.days);
                    mySelectedProfile.timeSpans[index] = updatedTs;
                } else {
                    let timespans = mySelectedProfile.timeSpans;
                    timespans.push({days:values.dow.value,                 
                        startHour: startTime.getHours(),
                        startMinute: startTime.getMinutes(),
                        endHour: endTime.getHours(),
                        endMinute: endTime.getMinutes()});
                        mySelectedProfile.timeSpans = timespans;
                }
            } else {
                if(myTs) {
                    const index = selectedProfile?.timeSpans.findIndex(ts => ts.days === values.dow.value);
                    mySelectedProfile.timeSpans.splice(index,1);
                }
            }
            setSelectedProfile(mySelectedProfile)
            setEdited(false);
        } 
    },[values, edited])


    const handleDatehange = (date, field) => {
        var value = formatISO(date);
        setEdited(true);
        setValues(values => {return {
            ...values,
            [field]: value
        }})
    };
    
    const handleInclusionChange = (event) => {
        const update = event.target.checked;
        setEdited(true);
        setValues(values => { return {
            ...values,
            included: update
        }})
    }

    return (
        <Grid
            item
            lg={1.5}
            md={6}
            xs={12}
        >
            <Stack spacing={3}>
                <FormControlLabel control={<Checkbox checked={values.included} onChange={handleInclusionChange} />} label={values.dow.name} />
                <TimePicker
                    renderInput={(params) => <TextField {...params} />}
                    value={values.starttime}
                    label="Start Time"
                    onChange={(date) => handleDatehange(date, 'starttime')}
                />
                <TimePicker
                    renderInput={(params) => <TextField {...params} />}
                    value={values.endtime}
                    label="End Time"
                    onChange={(date) => handleDatehange(date, 'endtime')}
                />
            </Stack>
        </Grid>

    )
}

export const TimeSpans = (props) => { 
    const selectedProfile = props.selectedProfile;
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Box sx={{marginBottom: 2}}>
            <Typography variant="body2">Select Days and Times when you want to receive email notifications of traffic incidents and/or roadwork. At least one day of week must be selected in order to receive notifications.</Typography>
            </Box>
            <Grid
                container
                spacing={3}
            >
                {daysofweek.map(dow => {
                    const myTs = selectedProfile.timeSpans.find(ts => ts.days === dow.value);
                    return <TimeSpan timespan={{ dow: dow, starttime: "2014-08-18T06:00:00", endtime: "2014-08-18T21:00:00", included:false }} key={dow.value} myTs={myTs} {...props}/>

                })}
            </Grid>
        </LocalizationProvider>
    )
}